import React, { useEffect, useState } from 'react';
import { Badge, Button, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import DatePicker from "react-datepicker";

import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import FalconCloseButton from 'components/common/FalconCloseButton';
import { Link } from 'react-router-dom';

import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useToast } from 'context/providers/ToastProvider';
import useToken from 'hooks/useToken';
import PropTypes from 'prop-types';
import masterCardImg from 'assets/img/illustrations/mastercard.png';
import visaImg from 'assets/img/illustrations/visaIcon.jpg';

const ModalConciliarPago = ({
    showModalConciliar,
    setShowModalConciliar,
    idPago,
    onPagoActualizado
}) => {
    const { token, setToken, idCatTipoUsuario } = useToken();
    const [Modal_idCatMedioPago, setModal_idCatMedioPago] = useState('');
    const [Modal_vCardCompany, setModal_vCardCompany] = useState('');
    const [Modal_dTipoCambio, setModal_dTipoCambio] = useState('1.0000');
    const [Modal_idCatFormaPago, setModal_idCatFormaPago] = useState('');
    const [Modal_idCatCuentaBancaria, setModal_idCatCuentaBancaria] = useState('');
    const [Modal_vReferencia, setModal_vReferencia] = useState('');
    const [CargandoModalConciliar, setCargandoModalConciliar] = useState(true);
    const [StateEditarModal, setStateEditarModal] = useState(false);
    const [EsConciliado, setEsConciliado] = useState(false);
    const [monedaEditada, setMonedaEditada] = useState('');
    const { showErrorToast, showSuccessToast } = useToast();

    const [ordenObj, setOrdenObj] = useState({});
    const [FechaPago, setFechaPago] = useState('');
    const [NotasInputText, setNotasInputText] = useState('');

    const [cuentas, setCuentas] = useState([]);
    const [mediosPago, setMediosPago] = useState([]);
    const [formasPago, setFormasPago] = useState([]);
    const [monedas, setMonedas] = useState([]);
    const [vendedores, setVendedores] = useState([]);
    const [Modal_idVendedor, setModal_idVendedor] = useState('');
    const [showCancelarPagoModal, setShowCancelarPagoModal] = useState(false);
    const [motivoCancelacionPago, setMotivoCancelacionPago] = useState('');
    const [procesandoCancelacion, setProcesandoCancelacion] = useState(false);


    /**
     * Obtiene el catálogo de monedas
     */
    const ObtenerCatMonedas = async () => {
        const response = await fetch("/api/contabilidad/CatalogoSAT/ObtenerCatMonedas", {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {
            const data = await response.json();

            if (data.iResponseType == 1) {
                var ObjDetalles = JSON.parse(data.detalles);
                setMonedas(ObjDetalles.table2 || ObjDetalles.Table2 || []);
            } else {
                showErrorToast(data.vMessage);
            }
        } else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    }

    /**
    * Obtiene el pago por Identificador numerico
    */
    const obtenerPagoByIDPago = async () => {
        setStateEditarModal(false);
        setCargandoModalConciliar(true);
        const response = await fetch("/api/conciliacion/obtenerPagoPorID/?idPago=" + idPago,
            {
                method: 'POST',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            }).catch((error) => {

                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {
            const responseType = await response.json();
            console.log(responseType);

            if (responseType.iResponseType == 1) {
                const data = JSON.parse(responseType.detalles);

                console.log(data);
                var pago_ = data['table1'][0];

                let parsedJson = {};
                if (pago_.vJsonDetallesLinkPago && pago_.vJsonDetallesLinkPago !== "undefined") {
                    parsedJson = JSON.parse(pago_.vJsonDetallesLinkPago);
                }

                pago_.objDataExtra = parsedJson;

                setOrdenObj(pago_);
                setMonedaEditada(data['table1'][0].vMoneda);
                setModal_idCatMedioPago(data['table1'][0].idCatMedioPago);
                setModal_idCatFormaPago(data['table1'][0].idCatFormaPago);
                setModal_idCatCuentaBancaria(data['table1'][0].idCatCuentaBancaria);
                setModal_vReferencia(data['table1'][0].vReferencia);
                setModal_vCardCompany(parsedJson.vCardCompany || "");

                setModal_dTipoCambio(data['table1'][0].dTipoCambio);

                setFechaPago(new Date(data['table1'][0].dFechaPago));
                setNotasInputText(data['table1'][0].vNotasConciliacion);
                setEsConciliado(data['table1'][0].bIsFacturado);

                setCuentas(data['table2']);
                setMediosPago(data['table3']);
                setFormasPago(data['table4']);
                setVendedores(data['table5'] || []);
                setModal_idVendedor(data['table1'][0].idVendedor ? data['table1'][0].idVendedor.toString() : '');

            } else {

                setShowModalConciliar(false);

                showErrorToast(responseType.vMessage);
                //console.log(response);
            }

        }
        else {
            setShowModalConciliar(false);


            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            console.log(response);
        }
        setCargandoModalConciliar(false);


    }

    /**
     * Gaurda la conciliacion
     */
    const onSubmitConciliacion = async (flagConciliar) => {

        var data = {};

        data.Notas = (NotasInputText == null) ? "" : NotasInputText;
        //data.dFechaPago = FechaPago;
        data.dFechaPago = new Date(FechaPago).toISOString();
        data.idPago = ordenObj.idPago;

        console.log(JSON.stringify(data));

        setCargandoModalConciliar(true);

        const response = await fetch("/api/conciliacion/Conciliar/?notas=" + encodeURIComponent(data.Notas) + /*"&fechaPago=" + data.dFechaPago +*/ "&idPago=" + data.idPago + "&flagConciliar=" + flagConciliar, {
            method: 'POST',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        })
            .catch((error) => {

                showErrorToast('' + error.message);


                console.log('Hubo un problema con la peticion Fetch:' + error.message);
            });

        if (response.ok) {
            const responseType = await response.json();
            console.log(responseType);

            if (responseType.iResponseType == 1) {

                obtenerPagoByIDPago(ordenObj.idPago);

                showSuccessToast("El pago #" + ordenObj.idPago + " ha sido " + (flagConciliar == "1" ? "Conciliado" : "Desconciliado"));

                if (onPagoActualizado) onPagoActualizado();

                //ObtenerPagos();

            } else {

                showErrorToast(responseType.vMessage);


            }

            setCargandoModalConciliar(false);
        }
        else {

            showErrorToast(response.status + ' ' + response.statusText);


            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            console.log(response);
            setCargandoModalConciliar(false);

        }

    };

    /**
     * Maneja la función para activar el pago si esta desactivado
     */    const handdleActivarPago = async (data) => {
        if (data === "0") {
            setShowCancelarPagoModal(true);
            return;
        }

        await procesarActivarPago("1", "");
    };

    const confirmarCancelacionPago = async () => {
        if (!motivoCancelacionPago.trim()) {
            showErrorToast('Debe ingresar un motivo para cancelar el pago.');
            return;
        }
        setProcesandoCancelacion(true);
        await procesarActivarPago("0", motivoCancelacionPago);
        setProcesandoCancelacion(false);
        setShowCancelarPagoModal(false);
    };

    const procesarActivarPago = async (data, motivo = "") => {
        setShowModalConciliar(true);
        setCargandoModalConciliar(true);

        let url = "/api/conciliacion/activaPago/?idPago=" + ordenObj.idPago + "&bIsActive=" + data;
        if (motivo) {
            url += "&vMotivo=" + encodeURIComponent(motivo);
        }

        const response = await fetch(url, {
            method: 'POST',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        })
            .catch((error) => {
                showErrorToast('' + error.message);
                console.log('Hubo un problema con la peticion Fetch:' + error.message);
            });

        if (response.ok) {
            const responseType = await response.json();
            console.log(responseType);

            if (responseType.iResponseType == 1) {

                showSuccessToast("El pago #" + ordenObj.idPago + " ha sido " + ((data == "1") ? "Activado" : "Cancelado"));

                if (onPagoActualizado) onPagoActualizado();

                reset();
                obtenerPagoByIDPago(ordenObj.idPago);

                setCargandoModalConciliar(false);

            } else {


                showErrorToast(responseType.vMessage);
                setCargandoModalConciliar(false);
            }
        }
        else {

            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            console.log(response);
            setCargandoModalConciliar(false);
        }

    }


    /**
     * Edita caracteristicas del pago
     * @param {any} vMoneda_
     * @param {any} dTipoCambio_
     * @param {any} idCatMedioPago_
     * @param {any} idCatFormaPago_
     * @param {any} idCatCuentaBancaria_
     * @param {any} FechaPago_
     * @param {any} vReferencia_
     */
    const handdleEditarPago = async (vMoneda_, dTipoCambio_, idCatMedioPago_, idCatFormaPago_, idCatCuentaBancaria_, FechaPago_, vReferencia_, idVendedor_) => {
        var data = {};

        data.idPago = ordenObj.idPago;
        data.vMoneda = (vMoneda_ == null) ? "" : vMoneda_;
        data.dTipoCambio = dTipoCambio_;
        data.idCatMedioPago = (idCatMedioPago_ == 0 || idCatMedioPago_ == null || idCatMedioPago_ === "") ? "0" : idCatMedioPago_;
        data.idCatFormaPago = (idCatFormaPago_ == 0 || idCatFormaPago_ == null || idCatFormaPago_ === "") ? "0" : idCatFormaPago_;
        data.idCatCuentaBancaria = (idCatCuentaBancaria_ == 0 || idCatCuentaBancaria_ == null || idCatCuentaBancaria_ === "") ? "0" : idCatCuentaBancaria_;
        data.vReferencia = (vReferencia_ == null) ? "" : vReferencia_;
        data.dFechaPago = new Date(FechaPago_).toISOString();

        if (!ordenObj.objDataExtra) {
            ordenObj.objDataExtra = {};
        }
        ordenObj.objDataExtra.vCardCompany = Modal_vCardCompany;

        data.vJsonDetallesLinkPago = encodeURIComponent(JSON.stringify(ordenObj.objDataExtra));
        console.log(JSON.stringify(data));

        setCargandoModalConciliar(true);

        const response = await fetch("/api/conciliacion/editarPago/?idPago=" + data.idPago + "&vMoneda=" + data.vMoneda +
            "&dTipoCambio=" + data.dTipoCambio + "&idCatMedioPago=" + data.idCatMedioPago + "&idCatFormaPago=" + data.idCatFormaPago +
            "&dFechaPago=" + data.dFechaPago + "&idCatCuentaBancaria=" + data.idCatCuentaBancaria + "&vReferencia=" + data.vReferencia + "&vJsonDetallesLinkPago=" + data.vJsonDetallesLinkPago + "&vNotas=" + encodeURIComponent(NotasInputText || '') + "&idVendedor=" + (idVendedor_ || ''), {
            method: 'POST',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        })
            .catch((error) => {

                showErrorToast('' + error.message);
                console.log('Hubo un problema con la peticion Fetch:' + error.message);
            });

        if (response.ok) {
            const responseType = await response.json();
            console.log(responseType);

            if (responseType.iResponseType == 1) {
                setStateEditarModal(false);
                obtenerPagoByIDPago(ordenObj.idPago);

                showSuccessToast("El pago #" + ordenObj.idPago + " ha sido editado correctamente");

                if (onPagoActualizado) onPagoActualizado();


                //ObtenerPagos();

            } else {


                showErrorToast(responseType.vMessage);
            }

            setCargandoModalConciliar(false);
        }
        else {

            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            console.log(response);
            setCargandoModalConciliar(false);

        }

    }

    useEffect(() => {
        obtenerPagoByIDPago();
        ObtenerCatMonedas();
    }, [])

    /**
     * Hace reset a los estados
     */
    const reset = async () => {
        setOrdenObj({});
        setNotasInputText('');
        setFechaPago('');
        setEsConciliado(false);
    }
    const renderMedioPagoBadge = (medioPagoText) => {
        if (!medioPagoText) return <span className="text-500">Desconocido</span>;
        const upper = medioPagoText.toUpperCase();

        let imgSrc = null;
        let imgWidth = 20; // slightly larger for the modal, or keep 16/24

        if (upper.includes('EFECTIVO')) { imgSrc = "/img/efectivo20.png"; }
        else if (upper.includes('STRIPE')) { imgSrc = "/img/stripe30.png"; imgWidth = 30; }
        else if (upper.includes('PAYPAL')) { imgSrc = "/img/paypal20.png"; }
        else if (upper.includes('BANCO') || upper.includes('TRANSFERENCIA') || upper.includes('SPEI')) { imgSrc = "/img/transferencia20.png"; }

        return (
            <Row className="align-items-center gap-2 fw-bold text-dark g-0 flex-nowrap w-auto">
                {imgSrc && <Col xs="auto"><img src={imgSrc} alt={medioPagoText} width={imgWidth} /></Col>}
                <Col xs="auto"><span>{medioPagoText}</span></Col>
            </Row>
        );
    };


    const InfoGeneralSection = (
        <>
            <h6 className="text-500 fw-bold fs--2 text-uppercase mb-3" style={{ letterSpacing: '0.5px' }}>Información General</h6>

            <Row className="mb-2 pb-1 border-bottom border-200 align-items-center">
                <Col xs={5} className="text-500 fw-semi-bold fs--1">Orden</Col>
                <Col xs={7} className="text-end">
                    <Link to={`/ordenes/detalle/${ordenObj.idOrden}`} className="text-primary text-decoration-none fs--1">
                        #{ordenObj.idOrden}
                    </Link>
                </Col>
            </Row>
            <Row className="mb-2 pb-1 border-bottom border-200 align-items-center">
                <Col xs={5} className="text-500 fw-semi-bold fs--1">Vendedor</Col>
                <Col xs={7} className="text-800 text-uppercase fs--1 text-end">{ordenObj.vNombreVendedor || "Sin Especificar"}</Col>
            </Row>
            <Row className="mb-2 pb-1 border-bottom border-200 align-items-center">
                <Col xs={5} className="text-500 fw-semi-bold fs--1">Fecha de Pago</Col>
                <Col xs={7} className="text-800 text-capitalize fs--1 text-end">{ordenObj.dFechaPagoLargo}</Col>
            </Row>

            {ordenObj.objDataExtra && (ordenObj.objDataExtra.vClientName || ordenObj.objDataExtra.vBank || ordenObj.objDataExtra.vLastFourCardDigits) && (
                <div className="mt-3">
                    <span className="text-500 fw-semi-bold fs--1 d-block mb-1">Datos Extras:</span>
                    <div className="bg-light p-2 rounded-3 fs--2 text-800">
                        {ordenObj.objDataExtra.vClientName && <div className="mb-1">Titular: {ordenObj.objDataExtra.vClientName}</div>}
                        {ordenObj.objDataExtra.vBank && <div className="mb-1">Banco: {ordenObj.objDataExtra.vBank}</div>}
                        {ordenObj.objDataExtra.vLastFourCardDigits && <div>Tarjeta: *{ordenObj.objDataExtra.vLastFourCardDigits}</div>}
                    </div>
                </div>
            )}
        </>
    );

    const EstadoMontoSection = (
        <>
            <h6 className="text-500 fw-bold fs--2 text-uppercase mb-3" style={{ letterSpacing: '0.5px' }}>Estado y Monto</h6>

            <Row className="bg-light rounded-4 p-3 text-center border border-200 justify-content-center align-items-center g-0">
                <Col xs={12} className="text-500 fs--2 fw-semi-bold mb-1">Importe Total</Col>
                <Col xs={12} className="d-flex align-items-baseline justify-content-center gap-2 mb-0">
                    <span className="display-6 fw-semi-bold text-dark" style={{ letterSpacing: '-1px' }}>
                        {ordenObj.dImportePago?.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
                    </span>
                    <span className="display-6 fw-semi-bold text-600">{ordenObj.vMoneda}</span>
                </Col>
                {ordenObj.vMoneda !== 'MXN' && (
                    <Col xs={12} className="text-muted fs--2 mb-3 mt-0">TC: {ordenObj.dTipoCambio}</Col>
                )}

                <Col xs={12} className="d-flex flex-wrap justify-content-center align-items-center gap-1 mt-1">
                    {/* Status Badges */}
                    {ordenObj.bIsActive == 1 ? (
                        <Badge bg="success" pill className="d-flex align-items-center gap-1 fw-normal px-2 fs--2"><FontAwesomeIcon icon={icon({ name: 'check' })} /> Activo</Badge>
                    ) : (
                        <Badge bg="danger" pill className="d-flex align-items-center gap-1 fw-normal px-2 fs--2"><FontAwesomeIcon icon={icon({ name: 'xmark' })} /> Inactivo</Badge>
                    )}

                    {ordenObj.idCatCuentaBancaria > 0 ? (
                        <Badge bg="success" pill className="d-flex align-items-center gap-1 fw-normal px-2 fs--2"><FontAwesomeIcon icon={icon({ name: 'check' })} /> Validado</Badge>
                    ) : (
                        <Badge bg="danger" pill className="d-flex align-items-center gap-1 fw-normal px-2 fs--2"><FontAwesomeIcon icon={icon({ name: 'xmark' })} /> No Validado</Badge>
                    )}

                    {EsConciliado ? (
                        <Badge bg="success" pill className="d-flex align-items-center gap-1 fw-normal px-2 fs--2"><FontAwesomeIcon icon={icon({ name: 'check' })} /> Conciliado</Badge>
                    ) : (
                        <Badge bg="danger" pill className="d-flex align-items-center gap-1 fw-normal px-2 fs--2"><FontAwesomeIcon icon={icon({ name: 'xmark' })} /> No Conciliado</Badge>
                    )}

                    {ordenObj.bIsFacturado == 1 && (
                        <Badge bg="info" pill className="d-flex align-items-center gap-1 fw-normal px-2 fs--2"><FontAwesomeIcon icon={icon({ name: 'file-invoice' })} /> Facturado</Badge>
                    )}
                </Col>
            </Row>
        </>
    );

    const InfoBancariaSection = (
        <>
            <h6 className="text-500 fw-bold fs--2 text-uppercase mb-3" style={{ letterSpacing: '0.5px' }}>Información Bancaria</h6>

            <Row className="mb-2 pb-1 border-bottom border-200 align-items-center">
                <Col xs={5} className="text-500 fw-semi-bold fs--1">Medio de Pago</Col>
                <Col xs={7} className="text-800 text-uppercase fs--1 text-end d-flex justify-content-end">
                    {renderMedioPagoBadge(mediosPago.find(m => m.idCatMedioPago == ordenObj.idCatMedioPago)?.vMedioPago || "Desconocido")}
                </Col>
            </Row>
            <Row className="mb-2 pb-1 border-bottom border-200 align-items-center">
                <Col xs={5} className="text-500 fw-semi-bold fs--1">Forma de Pago</Col>
                <Col xs={7} className="d-flex align-items-center justify-content-end gap-2 text-end">
                    {(ordenObj.objDataExtra?.vCardCompany?.toLowerCase() === 'visa') && <img src={visaImg} alt="visa" width="30" />}
                    {(ordenObj.objDataExtra?.vCardCompany?.toLowerCase() === 'mastercard') && <img src={masterCardImg} alt="mastercard" width="30" />}
                    <span className="text-800 text-uppercase fs--1">{formasPago.find(f => f.idCatFormaPago == ordenObj.idCatFormaPago)?.vDescripcionFormaPago || "No especificada"}</span>
                </Col>
            </Row>
            <Row className="mb-2 pb-1 border-bottom border-200 align-items-center">
                <Col xs={5} className="text-500 fw-semi-bold fs--1">Cuenta Bancaria</Col>
                <Col xs={7} className="text-800 fs--1 text-end">
                    {cuentas.find(c => c.idCatCuentaBancaria == ordenObj.idCatCuentaBancaria)?.vNombreBanco || "N/A"}
                    {ordenObj.idCatCuentaBancaria > 0 && <><br /> *{cuentas.find(c => c.idCatCuentaBancaria == ordenObj.idCatCuentaBancaria)?.vNumCta?.slice(-4)}</>}
                </Col>
            </Row>
        </>
    ); let historialEventos = [];

    // Cancelado
    if (ordenObj.bIsActive == 0 || ordenObj.dFechaCancelacion) {
        historialEventos.push({
            Accion: "CANCELADO",
            vUsuario: ordenObj.vUsuarioCancelacion || ordenObj.vUsuarioActualizacion || "Administrador",
            dFecha: ordenObj.dFechaCancelacion || ordenObj.dFechaActualizacion,
            vMotivo: ordenObj.vMotivoCancelacion
        });
    }

    // Activado
    if (ordenObj.dFechaActivacion) {
        historialEventos.push({
            Accion: "ACTIVADO",
            vUsuario: ordenObj.vUsuarioActivacion,
            dFecha: ordenObj.dFechaActivacion
        });
    }

    // Validado
    if (ordenObj.idCatCuentaBancaria > 0 || ordenObj.dFechaValidacion) {
        historialEventos.push({
            Accion: "VALIDADO",
            vUsuario: ordenObj.vUsuarioValidacion || ordenObj.vUsuarioCreador || ordenObj.vNombreCliente || "Desconocido",
            dFecha: ordenObj.dFechaValidacion || ordenObj.dFechaCreacionPago
        });
    }

    // Conciliado
    if (EsConciliado || ordenObj.dFechaConciliacion) {
        historialEventos.push({
            Accion: "CONCILIADO",
            vUsuario: ordenObj.vUsuarioConciliador || "Administrador",
            dFecha: ordenObj.dFechaConciliacion || ordenObj.dFechaCreacionPago,
            vMotivo: ordenObj.vNotasConciliacion
        });
    }

    // Facturado
    if (ordenObj.bIsFacturado == 1 || ordenObj.dFechaFacturacion) {
        historialEventos.push({
            Accion: "FACTURADO",
            vUsuario: ordenObj.vUsuarioFacturacion || ordenObj.vUsuarioConciliador || "Administrador",
            dFecha: ordenObj.dFechaFacturacion || ordenObj.dFechaConciliacion || ordenObj.dFechaCreacionPago
        });
    }

    // Desconciliado
    if (!EsConciliado && ordenObj.dFechaDesconciliacion) {
        historialEventos.push({
            Accion: "DESCONCILIADO",
            vUsuario: ordenObj.vUsuarioDesconciliacion,
            dFecha: ordenObj.dFechaDesconciliacion
        });
    }

    // Ordenar de más reciente a más antiguo
    if (historialEventos.length > 0) {
        historialEventos.sort((a, b) => new Date(b.dFecha) - new Date(a.dFecha));
    }

    const HistorialSection = (
        <>
            <h6 className="text-500 fw-bold fs--2 text-uppercase mb-3" style={{ letterSpacing: '0.5px' }}>Historial de Transacción</h6>

            <div style={{ maxHeight: '300px', overflowY: 'auto', overflowX: 'hidden' }} className="pe-2">
                <div className="timeline-vertical position-relative ps-3 ms-2 border-start border-200 pb-1 g-0">

                    {historialEventos.length > 0 && (
                        historialEventos.map((evento, index) => {
                            let colorStr = "primary";
                            let title = "Evento";
                            if (evento.Accion === "CANCELADO") { colorStr = "danger"; title = "Pago Cancelado"; }
                            else if (evento.Accion === "ACTIVADO") { colorStr = "success"; title = "Pago Activado"; }
                            else if (evento.Accion === "CONCILIADO") { colorStr = "success"; title = "Pago Conciliado"; }
                            else if (evento.Accion === "DESCONCILIADO") { colorStr = "warning"; title = "Pago Desconciliado"; }
                            else if (evento.Accion === "EDITADO") { colorStr = "info"; title = "Pago Editado"; }
                            else if (evento.Accion === "VALIDADO") { colorStr = "success"; title = "Pago Validado"; }
                            else if (evento.Accion === "FACTURADO") { colorStr = "info"; title = "Pago Facturado"; }

                            return (
                                <div key={index} className="position-relative mb-3">
                                    <span className={`position-absolute bg-${colorStr} rounded-circle`} style={{ width: '8px', height: '8px', left: '-20px', top: '5px' }}></span>
                                    <h6 className={`mb-1 fw-semi-bold text-${colorStr} fs--1`}>{title}</h6>
                                    <div className="d-flex flex-column">
                                        <div>
                                            <span className="text-800 fs--2 fw-semi-bold">{evento.vUsuario || "Desconocido"}</span>
                                        </div>
                                        <div>
                                            <span className="text-800 fs--2 fw-semi-bold text-muted">{evento.dFecha ? new Date(evento.dFecha).toLocaleString('es-MX') : "-"}</span>
                                        </div>
                                        {evento.vMotivo && (
                                            <div className="mt-1">
                                                <span className="text-400 fs--2 d-block">Motivo / Notas:</span>
                                                <p className="text-800 fs--2 mb-0 fst-italic">{evento.vMotivo}</p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            );
                        })
                    )}

                    {/* TIMELINE ITEM: ORDEN CREADA */}
                    <div className="position-relative">
                        <span className="position-absolute bg-300 rounded-circle" style={{ width: '8px', height: '8px', left: '-20px', top: '5px' }}></span>
                        <h6 className="mb-1 fw-semi-bold text-800 fs--1">Pago Creado</h6>
                        <div className="d-flex flex-column">
                            <div>
                                <span className="text-800 fs--2 fw-semi-bold text-primary">{ordenObj.vUsuarioCreador || ordenObj.vNombreCliente || "Cliente"}</span>
                            </div>
                            <div>
                                <span className="text-800 fs--2 fw-semi-bold text-muted">{ordenObj.dFechaCreacionOrden ? new Date(ordenObj.dFechaCreacionOrden).toLocaleString('es-MX') : "-"}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

    const BtnCancelarActivar = (
        <>
            {ordenObj.bIsActive == 1 ? (
                <Button variant="outline-danger" className="border-0 shadow-none fw-semi-bold px-0 px-md-3 bg-transparent hover-bg-danger-subtle text-danger w-auto" onClick={() => setShowCancelarPagoModal(true)} disabled={CargandoModalConciliar}>
                    <FontAwesomeIcon icon={icon({ name: 'ban', style: 'solid' })} className="me-2" /> Cancelar Pago
                </Button>
            ) : (
                idCatTipoUsuario == 1 && !CargandoModalConciliar && (
                    <Button variant="outline-success" className="border-0 shadow-none fw-semi-bold px-0 px-md-3 bg-transparent hover-bg-success-subtle text-success w-auto" onClick={() => { handdleActivarPago("1") }}>
                        <FontAwesomeIcon icon={icon({ name: 'rotate-left', style: 'solid' })} className="me-2" /> Activar Pago
                    </Button>
                )
            )}
        </>
    );

    const BtnCerrar = (
        <Button variant="light" className="fw-semi-bold px-4 rounded-3 text-600 w-auto border border-200" onClick={() => { setShowModalConciliar(false); reset() }}>
            Cerrar
        </Button>
    );

    const BtnConciliarDesconciliar = (
        <>
            {ordenObj.bIsActive == 1 && idCatTipoUsuario == 1 && !EsConciliado && !CargandoModalConciliar && (
                <Button variant="primary" className="fw-semi-bold px-4 rounded-3 text-white w-100 w-md-auto" style={{ backgroundColor: '#00a389', borderColor: '#00a389' }} onClick={() => { onSubmitConciliacion("1"); }}>
                    <FontAwesomeIcon icon={icon({ name: 'circle-check', style: 'regular' })} className="me-2" /> Conciliar Pago
                </Button>
            )}
            {idCatTipoUsuario == 1 && EsConciliado && !CargandoModalConciliar && (
                <Button variant="outline-danger" className="fw-semi-bold px-4 rounded-3 w-100 w-md-auto" onClick={() => { onSubmitConciliacion("0"); }}>
                    Desconciliar Pago
                </Button>
            )}
        </>
    );

    return (
        <Modal
            show={showModalConciliar}
            onHide={() => { setShowModalConciliar(false); reset() }}
            size="lg"
            backdrop="static"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            contentClassName="border-0 shadow-lg rounded-4"
        >            <Modal.Header className="border-bottom-0 pb-0 pt-3 pt-md-4 px-3 px-md-4 position-relative">
                <Row className="align-items-start gap-2 gap-md-3 w-100 pe-4 g-0 flex-nowrap">
                    <Col xs="auto" className="bg-primary-subtle rounded-3 d-flex justify-content-center align-items-center flex-shrink-0" style={{ width: '45px', height: '45px' }}>
                        <FontAwesomeIcon icon={icon({ name: 'file-invoice', style: 'solid' })} className="text-primary fs-1" />
                    </Col>
                    <Col className="flex-grow-1">
                        <Row className="align-items-start gap-2 gap-md-3 g-0">
                            {ordenObj.idPago ? (
                                <Col xs="auto"><h4 className="mb-0 fw-semi-bold text-800" style={{ letterSpacing: '-0.5px', fontSize: 'clamp(1rem, 4vw, 1.25rem)' }}>Detalle del Pago #{ordenObj.idPago}</h4></Col>
                            ) : (
                                <Col xs="auto"><Skeleton width={220} height={25} /></Col>
                            )}
                            {!CargandoModalConciliar && ordenObj.idPago && (
                                <Col xs="auto">
                                    <Button variant="light" size="sm" className="p-1 px-2 border-0 shadow-none text-500 hover-bg-200 transition-base flex-shrink-0" style={{ marginTop: '-2px' }} onClick={() => setStateEditarModal(!StateEditarModal)} title="Editar pago">
                                        <FontAwesomeIcon icon={icon({ name: 'edit', style: 'solid' })} />
                                    </Button>
                                </Col>
                            )}
                        </Row>
                        <Row className="align-items-start gap-2 text-500 fs--1 mt-1 text-break g-0 flex-nowrap">
                            {ordenObj.idPago ? (
                                <>
                                    <Col xs="auto"><span>Referencia: <span className="text-700 fw-medium font-monospace">{ordenObj.vReferencia || "N/A"}</span></span></Col>
                                    {ordenObj.vReferencia && (
                                        <Col xs="auto" className="flex-shrink-0" style={{ marginTop: '1px' }}>
                                            <FontAwesomeIcon
                                                icon={icon({ name: 'copy', style: 'regular' })}
                                                className="cursor-pointer text-400 hover-text-primary transition-base"
                                                title="Copiar Referencia"
                                                onClick={() => { navigator.clipboard.writeText(ordenObj.vReferencia); showSuccessToast("Referencia copiada al portapapeles"); }}
                                            />
                                        </Col>
                                    )}
                                </>
                            ) : (
                                <Col xs="auto"><Skeleton width={150} /></Col>
                            )}
                        </Row>
                    </Col>
                </Row>
                <FalconCloseButton className="btn btn-sm transition-base p-0 text-500 position-absolute top-0 end-0 mt-3 mt-md-4 me-3 me-md-4" onClick={() => { setShowModalConciliar(false); reset() }} />
            </Modal.Header>

            <Modal.Body className="px-3 px-md-4 py-4 pt-4 pt-md-5">
                {!ordenObj.idPago ? (
                    <Row className="g-4">
                        <Col md={7} className="pe-md-4">
                            <Skeleton width={200} height={20} className="mb-3" />
                            <Skeleton count={3} height={35} className="mb-2" />
                            <Skeleton width={200} height={20} className="mt-4 mb-3" />
                            <Skeleton count={2} height={60} className="mb-3" />
                        </Col>
                        <Col md={5}>
                            <Skeleton height={200} className="mb-3 rounded-4" />
                        </Col>
                    </Row>
                ) : StateEditarModal ? (
                    <Form>
                        <Row className="g-3 mb-3">
                            <Col md={4}>
                                <Form.Group>
                                    <Form.Label className="fs--1 fw-semi-bold">Fecha de Pago</Form.Label>
                                    <DatePicker
                                        selected={FechaPago}
                                        onChange={(date) => setFechaPago(date)}
                                        className="form-control"
                                        dateFormat="dd/MMM/yyyy"
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group>
                                    <Form.Label className="fs--1 fw-semi-bold">Moneda</Form.Label>
                                    <Form.Select value={monedaEditada} onChange={(e) => setMonedaEditada(e.target.value)}>
                                        <option value="">Seleccione...</option>
                                        {monedas.map((m, i) => (
                                            <option key={i} value={m.vClaveMoneda}>{m.vClaveMoneda}</option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            {monedaEditada !== 'MXN' && (
                                <Col md={4}>
                                    <Form.Group>
                                        <Form.Label className="fs--1 fw-semi-bold">Tipo de Cambio</Form.Label>
                                        <Form.Control
                                            type="number"
                                            step="0.01"
                                            value={Modal_dTipoCambio}
                                            onChange={(e) => setModal_dTipoCambio(e.target.value)}
                                            disabled={monedaEditada === 'MXN'}
                                        />
                                    </Form.Group>
                                </Col>
                            )}
                        </Row>

                        <Row className="g-3 mb-3">
                            <Col md={4}>
                                <Form.Group>
                                    <Form.Label className="fs--1 fw-semi-bold">Medio de Pago</Form.Label>
                                    <Form.Select value={Modal_idCatMedioPago} onChange={(e) => setModal_idCatMedioPago(e.target.value)}>
                                        <option value="">Seleccione...</option>
                                        {mediosPago.map((m, i) => (
                                            <option key={i} value={m.idCatMedioPago}>{m.vMedioPago}</option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group>
                                    <Form.Label className="fs--1 fw-semi-bold">Forma de Pago</Form.Label>
                                    <Form.Select value={Modal_idCatFormaPago} onChange={(e) => setModal_idCatFormaPago(e.target.value)}>
                                        <option value="">Seleccione...</option>
                                        {formasPago.map((m, i) => (
                                            <option key={i} value={m.idCatFormaPago}>{m.vClave} - {m.vDescripcionFormaPago}</option>
                                        ))}
                                    </Form.Select>
                                    {formasPago.find(f => f.idCatFormaPago == Modal_idCatFormaPago) && (
                                        (formasPago.find(f => f.idCatFormaPago == Modal_idCatFormaPago).vClave?.trim() === '04' ||
                                            formasPago.find(f => f.idCatFormaPago == Modal_idCatFormaPago).vClave?.trim() === '28' ||
                                            formasPago.find(f => f.idCatFormaPago == Modal_idCatFormaPago).vDescripcionFormaPago?.toLowerCase().includes('tarjeta'))
                                    ) && (
                                            <div className="mt-3">
                                                <Form.Label className="fs--1 fw-semi-bold">Franquicia de la Tarjeta</Form.Label>
                                                <Form.Select value={Modal_vCardCompany} onChange={(e) => setModal_vCardCompany(e.target.value)}>
                                                    <option value="">Seleccione...</option>
                                                    <option value="visa">Visa</option>
                                                    <option value="mastercard">Mastercard</option>
                                                </Form.Select>
                                            </div>
                                        )}
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group>
                                    <Form.Label className="fs--1 fw-semi-bold">Cuenta Bancaria</Form.Label>
                                    <Form.Select value={Modal_idCatCuentaBancaria} onChange={(e) => setModal_idCatCuentaBancaria(e.target.value)}>
                                        <option value="0">Ninguna</option>
                                        {cuentas.map((c, i) => (
                                            <option key={i} value={c.idCatCuentaBancaria}>{c.vNombreBanco} - *{c.vNumCta?.slice(-4)}</option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row className="g-3 mb-3">
                            <Col md={12}>
                                <Form.Group>
                                    <Form.Label className="fs--1 fw-semi-bold">Referencia</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={Modal_vReferencia}
                                        onChange={(e) => setModal_vReferencia(e.target.value)}
                                        placeholder="Ej. SPEI 123456"
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row className="g-3 mb-3">
                            <Col md={12}>
                                <Form.Group>
                                    <Form.Label className="fs--1 fw-semi-bold">Vendedor</Form.Label>
                                    <Form.Select
                                        value={Modal_idVendedor ? Modal_idVendedor.toString() : ''}
                                        onChange={(e) => setModal_idVendedor(e.target.value)}
                                    >
                                        <option value="">Seleccione un vendedor...</option>
                                        {vendedores.map((v, i) => (
                                            <option key={i} value={v.idVendedor ? v.idVendedor.toString() : ''}>
                                                {v.vNombreVendedor}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row className="g-3">
                            <Col md={12}>
                                <Form.Group>
                                    <Form.Label className="fs--1 fw-semi-bold">Notas de Conciliación</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        value={NotasInputText}
                                        onChange={(e) => setNotasInputText(e.target.value)}
                                        placeholder="Agrega notas o detalles sobre este pago..."
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Form>
                ) : (
                    <>
                        {/* DESKTOP LAYOUT (2 Columns) */}
                        <Row className="g-4 d-none d-md-flex">
                            <Col md={7} className="pe-md-4">
                                {InfoGeneralSection}
                                <div className="mt-4">
                                    {HistorialSection}
                                </div>
                            </Col>
                            <Col md={5}>
                                {EstadoMontoSection}
                                <div className="mt-4">
                                    {InfoBancariaSection}
                                </div>
                            </Col>
                        </Row>

                        {/* MOBILE LAYOUT (1 Column in exact requested order) */}
                        <Row className="g-4 d-md-none">
                            <Col xs={12}>{EstadoMontoSection}</Col>
                            <Col xs={12}>{InfoGeneralSection}</Col>
                            <Col xs={12}>{InfoBancariaSection}</Col>
                            <Col xs={12}>{HistorialSection}</Col>
                        </Row>

                        <Row className="mt-2 g-4">
                            <Col md={12}>
                                <h6 className="text-500 fw-bold fs--2 text-uppercase mb-4" style={{ letterSpacing: '0.5px' }}>Notas del Pago</h6>
                                {ordenObj.vNotasConciliacion ? (
                                    <div className="bg-light p-3 rounded-3 border border-200" style={{ minHeight: '80px' }}>
                                        <p className="mb-0 text-800 fs--1 fst-italic">
                                            {ordenObj.vNotasConciliacion}
                                        </p>
                                    </div>
                                ) : (
                                    <div className="bg-light rounded-3 py-4 text-center">
                                        <div className="text-400 fs--1 fst-italic">No hay notas registradas.</div>
                                    </div>
                                )}
                            </Col>
                        </Row>
                    </>
                )}
            </Modal.Body>

            <Modal.Footer className="justify-content-between flex-column flex-md-row gap-3 border-0 px-3 px-md-4 pb-4 pt-3">
                {!ordenObj.idPago ? (
                    <div className="w-100 d-flex justify-content-between flex-column flex-md-row gap-3">
                        <Skeleton width={120} height={40} />
                        <Skeleton width={150} height={40} />
                    </div>
                ) : StateEditarModal ? (
                    <>
                        <div className="d-none d-md-block"></div>
                        <div className="d-flex flex-column flex-md-row gap-2 gap-md-3 align-items-center w-100 w-md-auto">
                            <Button variant="light" className="fw-semi-bold px-4 rounded-3 text-600 w-100 w-md-auto" onClick={() => setStateEditarModal(false)} disabled={CargandoModalConciliar}>
                                Cancelar
                            </Button>
                            <Button variant="primary" className="fw-semi-bold px-4 rounded-3 text-white d-flex align-items-center justify-content-center gap-2 w-100 w-md-auto" onClick={() => handdleEditarPago(monedaEditada, Modal_dTipoCambio, Modal_idCatMedioPago, Modal_idCatFormaPago, Modal_idCatCuentaBancaria, FechaPago, Modal_vReferencia, Modal_idVendedor)} disabled={CargandoModalConciliar}>
                                {CargandoModalConciliar && <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />}
                                Guardar Cambios
                            </Button>
                        </div>
                    </>
                ) : (
                    <>
                        {/* DESKTOP LAYOUT */}
                        <div className="w-100 d-none d-md-flex justify-content-between align-items-center">
                            <div>
                                {BtnCancelarActivar}
                            </div>
                            <div className="d-flex gap-3 align-items-center">
                                {BtnCerrar}
                                {BtnConciliarDesconciliar}
                            </div>
                        </div>

                        {/* MOBILE LAYOUT */}
                        <div className="w-100 d-flex flex-column gap-3 d-md-none">
                            <div className="d-flex justify-content-between align-items-center">
                                {BtnCancelarActivar}
                                {BtnCerrar}
                            </div>
                            {BtnConciliarDesconciliar}
                        </div>
                    </>
                )}
            </Modal.Footer>

            {/* Cancelation Modal */}
            <Modal
                show={showCancelarPagoModal}
                onHide={() => setShowCancelarPagoModal(false)}
                backdrop="static"
                centered
            >
                <Modal.Header closeButton className="border-bottom-0 pb-0">
                    <Modal.Title className="fs-3 text-danger">Cancelar Pago</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group>
                        <Form.Label className="fs--1">¿Cuál es el motivo por el que deseas cancelar el pago <strong className="text-primary">#{ordenObj.idPago}</strong>?</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            value={motivoCancelacionPago}
                            onChange={(e) => setMotivoCancelacionPago(e.target.value)}
                            placeholder="Escribe el motivo aquí..."
                            className="fs--1"
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer className="border-top-0 pt-0">
                    <Button variant="light" onClick={() => setShowCancelarPagoModal(false)} disabled={procesandoCancelacion}>
                        Cerrar
                    </Button>
                    <Button variant="danger" onClick={confirmarCancelacionPago} disabled={procesandoCancelacion} className="d-flex align-items-center gap-2">
                        {procesandoCancelacion ? (
                            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                        ) : null}
                        Confirmar Cancelación
                    </Button>
                </Modal.Footer>
            </Modal>
        </Modal>
    )
};

ModalConciliarPago.propTypes = {
    showModalConciliar: PropTypes.bool.isRequired,
    setShowModalConciliar: PropTypes.func.isRequired,
    idPago: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    onPagoActualizado: PropTypes.func
};

export default ModalConciliarPago;
